var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    [
      _c(
        "v-list-item",
        [
          _c("SoliAvatarBtn", {
            attrs: {
              title: "Assessment Lesson",
              subtitleBottom: "30 minutes",
              avatar: "/instruments-blue.webp",
              blue: "",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("input", {
                  lesson: true,
                  display: "Lesson",
                  name: "Assessment",
                })
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-list-item",
        [
          _c("SoliAvatarBtn", {
            attrs: {
              title: "Piano Lab Assessment",
              subtitleBottom: "15 minutes",
              avatar: "/apl-assessment.webp",
              blue: "",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("input", {
                  apl: true,
                  display: "Piano Lab",
                  name: "Piano Lab Assessment",
                  event: _vm.event,
                  instrument: _vm.instrument,
                })
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }